import { useQuery } from "@tanstack/react-query";
import { useAuth } from "./useAuth";
import { refreshPath } from "../../config.json";
import { getEnvSettings } from "../lib/utils";

const FIVE_MINUTES = 300000;

export function useRefreshAuth() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["refresh", user?.session],
    queryFn: () => getSessionAndExtend(user?.session),
    refetchInterval: FIVE_MINUTES,
    refetchIntervalInBackground: true,
    enabled: !!user?.session,
  });
}

type RenewResponse = {
  action: "renewresponse";
  error?: string;
  result: "failed" | "success";
  sessionlist?: string[];
};

async function getSessionAndExtend(session?: string) {
  const { baseUrl } = getEnvSettings();
  const response = await fetch(
    `${baseUrl}${refreshPath}?action=renewrequest&session=${session}&json=json`,
    {
      credentials: "include",
    }
  );

  const { sessionlist } = (await response.json()) as RenewResponse;

  if (!sessionlist?.length) return null;

  return Promise.all(
    sessionlist.map((x) =>
      // This call will extend the lifetime of the session and token with 30 minutes
      fetch(`${x}?action=renew&response=success&session=${session}&json=json`, {
        credentials: "include",
      })
    )
  );
}
